<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('warehouses')"
          :directory="[$t('warehouses'), $t('warehouse')]"
          :icon="'users'"
        />
      </div>
    </div>
    <div class="row">
        <div class="col-12 col-md-6 mb-3">
            <div class="d-flex justify-content-start">
                <app-input type="select" :class="'mr-4'" list-value-field="name" :list="warehouseQty"
                    :placeholder="$t('choose_an_warehouse_qty')" v-model="tabdate.qty" @input="getFilter" />
                <app-input type="select" :class="'mr-4'" list-value-field="name" :list="warehouseCat"
                    :placeholder="$t('choose_an_warehouse_cat')" v-model="tabdate.cat" @input="getFilter" />
            </div>
        </div>
        <div class="col-12 col-md-6 mb-3">
            <div class="d-flex justify-content-end align-items-center">
                <label class="col-2 pr-0 text-right">Дата с:</label>
                <app-input :class="'col-4'" v-model="tabdate.date_start" :placeholder="$t('choose_a_date')"
                    :popover-position="'top-end'" type="date" @input="getFilter" />
                <label class="col-1 pr-0 text-right">по:</label>
                <app-input :class="'col-4'" v-model="tabdate.date_end" :placeholder="$t('choose_a_date')"
                    :popover-position="'top-end'" type="date" @input="getFilter" />
            </div>
        </div>
    </div>
    <app-overlay-loader v-if="updateFilter" />
    <div class="row" v-else>
        <div class="col-12">
            <app-tab-warehouse :tabs="tabs" :tabdate="tabdate"/>
        </div>
    </div>
    
   
  </div>
</template>
<script>
import CoreLibrary from "@core/helpers/CoreLibrary.js";
import { collection, urlGenerator } from "@app/Helpers/helpers";
import {FormSubmitMixin} from "@app/Mixins/Global/FormSubmitMixin";
import { mapGetters } from "vuex";
export default {
  name: "Warehouse",
  extends: CoreLibrary,
  mixins: [FormSubmitMixin],
  data() {
    return {
        urlGenerator,
        updateFilter: false,
        isWarehouseModalActive: false,
        isWarehouseModalActiveItem: false,
        isContactModalActive: false,
        //tableId: "warehouse-modal",
        contacttableId: "contact-modal",
        warehouseQty: [
            {
                id: 1,
                name: this.$t('warehouse_qty_1')
            },
            {
                id: 2,
                name: this.$t('warehouse_qty_2')
            },
        ],
        warehouseCat: [
            {
                id: 0,
                name: this.$t('warehouse_cat_0')
            },
            {
                id: 1,
                name: this.$t('warehouse_cat_1')
            },
            {
                id: 2,
                name: this.$t('warehouse_cat_2')
            },
            {
                id: 3,
                name: this.$t('warehouse_cat_3')
            },
        ],
        tabs: [
            {
                "title": "tab_plus",
                "name": "tab_plus",
                "props": {
                    "type": "plus",
                }
            },
            {
                "title": "tab_minus",
                "name": "tab_minus",
                "props": {
                    "type": "minus",
                }
            },
            {
                "title": "tab_res",
                "name": "tab_res",
                "props": {
                    "type": "res",
                }
            },
        ],
        tabdate: {
            "qty": 1,
            "date_start": new Date(new Date - 2592000 * 1000),
            "date_end": new Date(),
            "cat": 0,
        },

    chartAll:[],

      
    };
  },
  methods: {
	  
	getFilter(){
        this.updateFilter = true;
            this.axiosGet('/crm/warehouse-reports/')
                .then((res) => {
                    this.chartAll = res.data;
                })
                .finally(() => {
                    this.updateFilter = false;
                });
        
    }
 
   

  },
  computed: {

  },
  mounted() {
  },
};
</script>
<style>
.link-list {
  white-space: nowrap !important;
  max-width: 180px;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
